import type { OTRequestFormValues } from "./OTRequestForm";

/** Sample form data for auto-fill on OT Request create page. workDate is filled with today when applying. */
export const otRequestFormSamples: Omit<OTRequestFormValues, "workDate">[] = [
  {
    startTime: "18:00",
    endTime: "21:00",
    reason: "ເຮັດວຽກເພີ່ມຕາມຄຳຂໍຈາກຜູ້ຈັດການ.",
  },
  {
    startTime: "08:00",
    endTime: "12:00",
    reason: "ວັນເສົາເຮັດວຽກພິເສດ ໂຄງການດັ່ງເດີມ.",
  },
  {
    startTime: "18:00",
    endTime: "22:00",
    reason: "",
  },
  {
    startTime: "13:00",
    endTime: "17:00",
    reason: "ປະຊຸມວັນອາທິດ ກອງປະຊຸມສຳຄັນ.",
  },
];
